// Builds a "Add to Google Calendar" template URL for an appointment.
export function googleCalendarUrl(appt) {
  const pad = (n) => String(n).padStart(2, "0");
  const toGCal = (d) =>
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

  const start = appt.start_at ? new Date(appt.start_at) : appt.start ? new Date(appt.start) : null;
  if (!start || isNaN(start.getTime())) return null;
  let end = appt.end ? new Date(appt.end) : new Date(start.getTime() + 60 * 60000);
  if (isNaN(end.getTime())) end = new Date(start.getTime() + 60 * 60000);

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: appt.title || "Appointment",
    dates: `${toGCal(start)}/${toGCal(end)}`,
    details: appt.notes || (appt.lead_name ? `Lead: ${appt.lead_name}` : ""),
    location: appt.location || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
